<template>

  <div class="section p-3 mb-4">
    <div class="row">

      <div class="col-md-12 section-title mb-4 d-flex justify-content-between">
        <div>{{sectionTitle}}</div>
        <div v-if="!isRequired" class="delete-button" @click="removeProjectDateConf"><trash-icon size="18"/></div>
      </div>

      <date-time-recurrence-field
        :date-conf="projectDateConf"
        :date-id="'date' + projectDateConf.index + '-input'"
        :start-time-id="'startTime' + projectDateConf.index + '-input'"
        :end-time-id="'endtime' + projectDateConf.index + '-input'">
      </date-time-recurrence-field>

    </div>
  </div>

</template>

<script>

import DateTimeField from "../../../components/b122/editFields/DateTimeField.vue";
import DateTimeRecurrenceField from "../../../components/b122/editFields/DateTimeRecurrenceField.vue";

export default {
  name: 'ProjectDateComponent',
  components: {DateTimeRecurrenceField, DateTimeField},

  props: {
    projectDateConf: {
      type: Object,
      default: null
    },
    isRequired: {
      type: Boolean,
      default: false
    },
    sectionTitle: {
      type: String,
      default: function () {
        return this.$t('project.section.Date') + (this.isRequired? this.$t('field.mandatory'): '')
      }
    }
  },

  emits: ['removedProjectDateConf'],

  methods: {

    removeProjectDateConf() {
      this.$emit('removedProjectDateConf', this.projectDateConf)
    }

  }
}

</script>

<style scoped>

.delete-button {
  color: var(--main-red);
  cursor: pointer;
}

.delete-button:hover {
  color: var(--main-red-hover)
}

</style>



// WEBPACK FOOTER //
// src/views/project/components/ProjectDateComponent.vue